import { FC } from "react";

import Skeleton from "../Skeleton/Skeleton";
import { TableSkeletonProps } from "./TableSkeleton.types";
import headerStyles from "./components/TableHeader/TableHeader.module.css";

import styles from "./Table.module.css";



const TableSkeleton: FC<TableSkeletonProps> = ({ 
  rows = 5, 
  columns = 4
}) => {
  const skeletonRows = Array.from({ length: rows }, (_, index) => index);
  const skeletonColumns = Array.from({ length: columns }, (_, index) => index);

  return (
    <div className={styles['table-container']}>
      <table className={styles['table']}>
        <thead>
          <tr>
            {skeletonColumns.map((columnIndex) => (
              <th key={columnIndex}>
                {columnIndex === 0 ? (
                  <Skeleton height={38} width={100} variant="text" />
                ) : (
                  <div className={headerStyles["table__brand-header-top"]}>
                    <Skeleton height={38} width={150} variant="text" />
                  </div>
                )}
              </th>
            ))}
          </tr>

          <tr className={headerStyles["table__header-icons-row"]}>
            {skeletonColumns.map((columnIndex) => {
              if (columnIndex === 0) {
                return (
                  <th
                    key={`${columnIndex}-empty`}
                    className={headerStyles["table__header-placeholder"]}
                    aria-hidden="true"
                  />
                );
              }

              return (
                <th 
                  key={`${columnIndex}-icons`}
                  className={headerStyles["table__header-icons-cell"]}
                >
                  <div className={headerStyles["table__brand-header-bottom"]}>
                    <Skeleton height={24} width={24} />
                    <Skeleton height={24} width={24} />
                    <Skeleton height={24} width={24} />
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {skeletonRows.map((rowIndex) => (
            <tr key={rowIndex}>
              {skeletonColumns.map((columnIndex) => (
                <td
                  key={columnIndex}
                  className={columnIndex === 0 ? undefined : styles["table__skeleton-metrics-cell"]}
                >
                  <div>
                    {columnIndex === 0 ? (
                      <Skeleton height={28} width={200} variant="text" />
                    ) : (
                      <div className={styles["table__skeleton-metrics"]}>
                        <Skeleton height={32} width={32} />
                        <Skeleton height={32} width={32} />
                        <Skeleton height={32} width={32} />
                      </div>
                    )}
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TableSkeleton;